import { cn } from "@/lib/utils";

export const Panel = ({ className, children, ...rest }) => (
  <div
    className={cn(
      "bg-white border border-slate-200 rounded-sm",
      "shadow-[0_1px_3px_rgba(15,23,42,0.06)]",
      className,
    )}
    {...rest}
  >
    {children}
  </div>
);

export const PanelHeader = ({ title, hint, action, className }) => (
  <div
    className={cn(
      "flex items-center justify-between px-4 py-3 border-b border-slate-200/70",
      className,
    )}
  >
    <div>
      <div className="text-[10px] tracking-[0.2em] uppercase font-bold text-slate-500">
        {title}
      </div>
      {hint && <div className="text-xs text-slate-600 mt-0.5">{hint}</div>}
    </div>
    {action && <div>{action}</div>}
  </div>
);

export const Kpi = ({ label, value, accent = "text-slate-900", testid, sub }) => (
  <Panel className="p-4" data-testid={testid}>
    <div className="text-[10px] tracking-[0.2em] uppercase font-bold text-slate-500">
      {label}
    </div>
    <div className={cn("mt-2 text-3xl font-data tracking-tight", accent)}>{value}</div>
    {sub && <div className="mt-1 text-xs text-slate-500 font-data">{sub}</div>}
  </Panel>
);
